<template>
  <svg viewBox="-4 -3 32 32" fill="none" fill-rule="evenodd" aria-hidden="true">
    <rect x="-4" y="-3" width="32" height="32" fill="#1B1B1F" />
    <path
      d="M21.751 22.607c1.34 1.005 3.35.335 1.508-1.508C17.73 15.74 18.904 1 12.037 1 5.17 1 6.342 15.74.815
      21.1c-2.01 2.009.167 2.511 1.507 1.506 5.192-3.517 4.857-9.714 9.715-9.714 4.857 0 4.522 6.197 9.714 9.715Z"
      fill="url(#antigravity-agent-icon)" />
    <defs>
      <linearGradient id="antigravity-agent-icon" x1="12" y1="23" x2="12" y2="1" gradientUnits="userSpaceOnUse">
        <stop stop-color="#3186FF" />
        <stop offset="0.35" stop-color="#00B95C" />
        <stop offset="0.65" stop-color="#FFE432" />
        <stop offset="1" stop-color="#FC413D" />
      </linearGradient>
    </defs>
  </svg>
</template>
